var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"lead text-center m-lg-5 mb-lg-4"},[_vm._v(_vm._s(_vm.$t('login-successful')))])
}
var staticRenderFns = []

export { render, staticRenderFns }